import { Injectable } from '@angular/core';
import { Parser } from 'expr-eval';

export interface CompiledRule {
  field: string;
  deps: string[];
  fn: (ctx: any) => any;
}

@Injectable({ providedIn: 'root' })
export class GraphCompiledEngine {

  private parser = new Parser();

  private rules = new Map<string, CompiledRule>();

  private depGraph = new Map<string, string[]>();

  compile(field: string, expr: string) {

    // ⭐ ERP SUM FIX
    const sumMatch =
        expr.match(/sum\((.+)\[\*\]\.(.+)\)/);

    if (sumMatch) {

        const arrayName = sumMatch[1];
        const childField = sumMatch[2];

        const rule: CompiledRule = {
        field,
        deps: [arrayName],
        fn: (ctx: any) => {

            const arr = ctx[arrayName];
            if (!Array.isArray(arr)) return 0;

            return arr.reduce(
            (t: number, r: any) =>
                t + Number(r?.[childField] || 0),
            0
            );
        }
        };

        this.rules.set(field, rule);

        if (!this.depGraph.has(arrayName))
        this.depGraph.set(arrayName, []);

        this.depGraph.get(arrayName)!
        .push(field);

        return;
    }

    // ⭐ NORMAL EXPRESSIONS
    const ast = this.parser.parse(expr);

    const deps = ast.variables();

    const rule: CompiledRule = {
        field,
        deps,
        fn: (ctx: any) => {
        try {
            return ast.evaluate(ctx);
        } catch {
            return null;
        }
        }
    };

    this.rules.set(field, rule);

    deps.forEach(d => {

        if (!this.depGraph.has(d))
        this.depGraph.set(d, []);

        this.depGraph.get(d)!.push(field);
    });
 }

  get(field: string) {
    return this.rules.get(field);
  }

  getAll() {
    return Array.from(this.rules.values());
  }

  getDependents(dep: string): string[] {
    return this.depGraph.get(dep) || [];
  }

  clear() {
    this.rules.clear();
    this.depGraph.clear();
  }
}